export const appName = 'Registre du Personnel Chantier'
